import { IBreadcrumb } from '@quicktools/shared-components/components/core/Breadcrumb/types';

import { ISymbolsCategory, ISymbol } from '../data/types';
import categories from '../data/symbolsData/categories';
// ugly hack used on mobile (but mainly helpful for Safari IOS)
// it moves the search input to the top when keyboard is opened
export const scrollToSearchInput = () => {
  window.setTimeout(() => {
    document && document?.querySelector('#sticky-search-input')?.scrollIntoView();
  }, 100);
};

export const mapSymbols = (baseSymbols: ISymbol[], categoryName: string): ISymbolsCategory => {
  const mappedSymbols = baseSymbols.map((symbol: ISymbol) => {
    return {
      ...symbol,
    };
  });

  return {
    category: categoryName,
    symbols: mappedSymbols,
  };
};

export const mapLastSublink = (sublink: IBreadcrumb): IBreadcrumb => {
  const sublinkParts = sublink.href.split('/');
  const category = categories.filter((c) => c.value == sublinkParts[sublinkParts.length - 1]);
  if (category.length == 0) return sublink;
  return {
    text: category[0].text,
    href: sublink.href,
  };
};
